import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LeadershipList"] */ "/app/src/components/new/Leadership/LeadershipList.tsx");
